/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const GET_UPC_DICT = gql`
  query UPCDict($upcs: [String!]!) {
    upcDict(upcs: $upcs)
  }
`
